import { render, staticRenderFns } from "./AyudaTemaSolicitudes.vue?vue&type=template&id=59ed835e"
import script from "./AyudaTemaSolicitudes.vue?vue&type=script&lang=js"
export * from "./AyudaTemaSolicitudes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports